import { render } from "./InventoryCenter.vue?vue&type=template&id=caec1634"
import script from "./InventoryCenter.vue?vue&type=script&lang=js"
export * from "./InventoryCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__